var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWasher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H12a6 6 0 00-6 6v22a4 4 0 004 4h20a4 4 0 004-4V10a6 6 0 00-6-6zm4 28c0 1.102-.898 2-2 2H10c-1.102 0-2-.898-2-2V10c0-2.206 1.794-4 4-4h16c2.206 0 4 1.794 4 4v22zM18.006 11.5c.825 0 1.494-.669 1.494-1.5s-.669-1.5-1.494-1.5a1.5 1.5 0 100 3zM13.5 10c0-.828-.668-1.5-1.5-1.5-.824 0-1.5.672-1.5 1.5s.676 1.5 1.5 1.5c.831 0 1.5-.669 1.5-1.5zm6.5 4c-4.97 0-8.944 4.031-8.944 9s4.029 9 8.944 9c4.915 0 8.944-4.031 8.944-9S24.969 14 20 14zm0 16c-3.56 0-6.475-2.683-6.912-6.129 1.403.475 2.98.297 4.231-.558a4.735 4.735 0 005.364-.005 4.73 4.73 0 002.625.833 5.37 5.37 0 001.605-.288C26.488 27.306 23.569 30 20 30zm5.337-7.856a2.74 2.74 0 01-1.94-.84.998.998 0 00-1.478.054c-1.016 1.012-2.877.999-3.87-.039a1.005 1.005 0 00-.717-.308c-.278.04-.531.107-.72.3-.936.962-2.386 1.042-3.471.337C13.769 18.43 16.606 16 20 16c3.411 0 6.25 2.456 6.869 5.691-.456.278-.988.409-1.532.453z",
    fill: "#fff"
  })));
}

export default SvgWasher;